import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'passwordless_login';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/PasswordlessLogin')));